<template>
  <main>
    <template v-if="this.confirm && this.coupon.prize_type !== '0'">
      <div class="freepass_confirm" ref="freepass_confirm">
        <div class="header">
          <span> {{ this.expireAtStr() }}</span>
          <div class="l_button__close">
            <button class="c_button__close" @click="tapClose">
              <img
                class="c_img c_close"
                src="../assets/img/buttons/small@3x.png"
              />
            </button>
          </div>
        </div>
        <div class="l_coupon__large" v-if="this.coupon.freepass_detail_image_url !==''">
          <img :src="this.coupon.freepass_detail_image_url" />
        </div>
         <!-- ご利用条件 -->
        <div class="condition">
          <div class="caption">ご利用条件</div>
          <div
              class="l_terms"
              :class="{ scroll_shadow: this.isShadow }"
              ref="terms_wrapper">
          <p class="c_terms">{{ this.termsStr }}</p>
        </div>
          <div class="expired">
            フリーパスのご利用期限は<br />
            獲得後{{ this.coupon.expire_days }}日間です。
          </div>
        </div>
        <div
          class="l_use"
          v-bind:class="{
            silver: this.coupon.prize_type === '1',
            gold: this.coupon.prize_type === '2',
            platina: this.coupon.prize_type === '3',
            diamond: this.coupon.prize_type === '4',
            bonus: this.coupon.prize_type === '5'
          }"
          v-if="this.showUseButton"
        >
          <div v-if="this.coupon.weborder_coupon_id" class="use_buttons">
            <div class="twobutton_wapper">
              <div @click="tapUseCoupon" class="twobutton">
                <div class="icon">
                  <img
                    :src="require('@/assets/img/coupon/eatin-takeout.png')"
                  />
                </div>
                <div>
                  <div>
                    <template v-if="this.coupon.not_eat_in === '0'"
                      >イートインまたは<br
                    /></template>
                    テイクアウトで使う
                  </div>
                  <div class="small">(店舗・お電話)</div>
                </div>
              </div>
            </div>
            <div class="twobutton_wapper with_border">
              <div @click="tapUseCouponWeborder" class="twobutton">
                <div class="icon">
                  <img :src="require('@/assets/img/coupon/joynet.png')" />
                </div>
                <div>
                  ネット注文で<br />
                  使う
                </div>
                <div class="small">(Joyネット)</div>
              </div>
            </div>
          </div>

          <div
            v-else
            class="l_use"
            v-bind:class="{
              silver: this.coupon.prize_type === '1',
              gold: this.coupon.prize_type === '2',
              platina: this.coupon.prize_type === '3',
              diamond: this.coupon.prize_type === '4',
              bonus: this.coupon.prize_type === '5'
            }"
          >
            <a @click="tapUseCoupon">このフリーパスを使う</a>
          </div>
        </div>
          <!-- USEボタン -->
          <!--<div
            class="l_use"
            v-bind:class="{
              silver: this.coupon.prize_type === '1',
              gold: this.coupon.prize_type === '2',
              platina: this.coupon.prize_type === '3',
              diamond: this.coupon.prize_type === '4',
              bonus: this.coupon.prize_type === '5'
            }"
            v-if="this.showUseButton"
          >
            <a @click="tapUseCoupon">このフリーパスを使う</a>
          </div>-->

          <!-- 利用中ボタン -->
          <div
            v-bind:class="{
              l_using: this.coupon.target_user_type === '0',
              l_using_premium: this.coupon.target_user_type !== '0'
            }"
            v-if="
              this.statusOfCoupon === this.statusRunning &&
                this.coupon.type !== '1'
            "
          >
            <div>
              <p class="c_using__title">ご利用日時</p>
              <p class="c_using__date">{{ this.usedDate }}</p>
            </div>
          </div>

          <!-- 利用終了ボタン -->
          <div class="l_used" v-if="this.statusOfCoupon === this.statusExpired">
            <p>ご利用可能時間が終了しました</p>
          </div>
          <!-- 利用終了ボタン -->
          <div
            class="l_used"
            v-if="this.statusOfCoupon === this.statusStampFull"
          >
            <p>スタンプをためて特典をもらおう！</p>
          </div>
          <!-- 利用終了ボタン -->
          <div
            class="l_used"
            v-if="this.statusOfCoupon === this.statusOffHours"
          >
            <p>クーポン利用可能期間外です</p>
          </div>
        </div>
      <div class="l_coupon__detail" ref="coupon_detail">
        <!-- アラート表示 -->
        <template v-if="this.isUseAlert">
          <alert-coupon
            :image="this.coupon.detail_image_url"
            :type="this.coupon.type"
            :isWeborder="this.isWeborder"
            @useCoupon="tapAcceptUseCoupon"
            @cancelCoupon="tapCancelUseCoupon"
          />
        </template>
      </div>
      <!-- エラーパネル -->
      <template v-if="this.isError">
        <error-popup
          :title="this.errorTitle"
          :message="this.errorMessage"
          :label="'閉じる'"
          @submit="() => tapRetryFetch()"
          @close="() => tapErrorClose()"
        />
      </template>
    </template>

    <template v-else-if="this.coupon.prize_type !== '0'">
      <div class="freepass" v-bind:class="couponColor()">
        <div class="image">
          <img :src="this.coupon.detail_image_url" />
          <div class="expire">{{ this.expireAtStr() }}</div>
        </div>
        <div class="usetime">
          ご利用時間
          <p>{{ this.usedDate }}</p>
        </div>

        <div class="detail">
          <p class="header">●ご利用条件</p>
          <div class="body">
            <p>{{ this.termsStr }}</p>
          </div>
        </div>
        <div class="close">
          <a class="close_button" @click="tapClose">閉じる</a>
        </div>
      </div>
      <div class="l_coupon__detail" ref="coupon_detail">
        <!-- アラート表示 -->
        <template v-if="this.isUseAlert">
          <alert-coupon
            :image="this.coupon.detail_image_url"
            :type="this.coupon.type"
            :isWeborder="this.isWeborder"
            @useCoupon="tapAcceptUseCoupon"
            @cancelCoupon="tapCancelUseCoupon"
          />
        </template>
      </div>
      <!-- エラーパネル -->
      <template v-if="this.isError">
        <error-popup
          :title="this.errorTitle"
          :message="this.errorMessage"
          :label="'閉じる'"
          @submit="() => tapRetryFetch()"
          @close="() => tapErrorClose()"
        />
      </template>
    </template>
    <template v-else>
      <div class="l_coupon__detail" ref="coupon_detail">
        <template v-if="this.coupon">
          <template v-if="this.coupon.target_user_type === '0'">
            <div class="l_coupon__header" v-if="this.coupon.type === '1'">
              <!-- giftee-->
              <div class="l_category c_pink">
                <img
                  class="c_category__img"
                  src="@/assets/img/gifteeicon.png"
                />
                <span class="c_category__label">デジタルギフト</span>
              </div>
              <!-- 有効期限 -->
              <div class="c_coupon__expire l_expireAt">
                <span class="c_expire__label"
                  >[有効期限]
                  {{
                    this.coupon.gift_expire
                      ? this.__createExpiredDate(this.coupon.gift_expire)
                      : 'ー'
                  }}
                </span>
                <div class="l_button__close">
                  <button class="c_button__close" @click="tapClose">
                    <img
                      class="c_img c_close"
                      src="../assets/img/buttons/small@3x.png"
                    />
                  </button>
                </div>
              </div>
            </div>
            <div class="l_coupon__header" v-else>
              <!-- 通常 -->
              <template v-if="this.coupon.coupon_category === '0'">
                <div class="l_category">
                  <span class="c_category__label">何度でもご利用可能</span>
                </div>
              </template>
              <!-- 期間限定-->
              <template v-if="this.coupon.coupon_category === '1'">
                <div class="l_category c_red">
                  <img
                    class="c_category__img"
                    src="@/assets/img/icon-date-picker.png"
                  />
                  <span class="c_category__label">期間限定</span>
                </div>
              </template>
              <!-- スタンプ特典-->
              <template v-if="this.coupon.coupon_category === '2'">
                <div class="l_category c_red">
                  <img
                    class="c_category__img"
                    src="@/assets/img/stampbenefits.svg"
                  />
                  <span class="c_category__label">特典</span>
                </div>
              </template>
              <!-- あなただけ-->
              <template v-if="this.coupon.coupon_category === '3'">
                <div class="l_category c_red">
                  <span class="c_category__label">あなただけ</span>
                </div>
              </template>
              <!-- 有効期限 -->
              <div class="c_coupon__expire l_expireAt">
                <span class="c_expire__label"> {{ this.expireAtStr() }}</span>
                <div class="l_button__close">
                  <button class="c_button__close" @click="tapClose">
                    <img
                      class="c_img c_close"
                      src="../assets/img/buttons/small@3x.png"
                    />
                  </button>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="l_coupon__header">
              <!-- プレミアム -->
              <div class="l_category_premium">
                <div class="inner">
                  <img src="~@/assets/img/premium/icon_coupon.svg" />
                </div>
                <div class="inner">
                  <span class="c_category__label">{{ this.categoryName }}</span>
                </div>
              </div>
              <!-- 有効期限 -->
              <div class="c_coupon__expire l_expireAt">
                <span class="c_expire__label"> {{ this.expireAtStr() }}</span>
                <div class="l_button__close">
                  <button class="c_button__close" @click="tapClose">
                    <img
                      class="c_img c_close"
                      src="../assets/img/buttons/small@3x.png"
                    />
                  </button>
                </div>
              </div>
            </div>
          </template>
          <!-- クーポン -->
          <div class="l_coupon">
            <template v-if="this.coupon.image_size === '1'">
              <div class="l_coupon__large">
                <img :src="this.coupon.detail_image_url" />
              </div>
            </template>
            <template v-else>
              <div
                class="l_coupon__left"
                :style="{
                  backgroundImage: 'url(' + this.coupon.detail_image_url + ')'
                }"
              ></div>
              <div class="l_coupon__right">
                <div class="c_coupon__title">{{ this.coupon.caption }}</div>
                <template v-if="this.coupon.is_html_display">
                  <div class="l_heading">
                    <div
                      class="c_coupon__subtitle"
                      v-html="this.coupon.heading_small"
                    ></div>
                    <div
                      class="c_coupon__heading"
                      :class="{ is_android: isAndroid }"
                      v-html="this.coupon.heading_large"
                    ></div>
                  </div>
                </template>
                <template v-if="!this.coupon.is_html_display">
                  <div class="l_heading">
                    <div class="c_coupon__subtitle">
                      {{ this.coupon.heading_small }}
                    </div>
                    <div
                      class="c_coupon__heading"
                      :class="{ is_android: isAndroid }"
                    >
                      {{ this.coupon.heading_large }}
                    </div>
                  </div>
                </template>
              </div>
            </template>
          </div>

          <!-- ご利用条件 -->
          <div class="l_condition">
            <div
              class="l_terms"
              :class="{ scroll_shadow: this.isShadow }"
              ref="terms_wrapper">
              <p class="c_terms">{{ this.termsStr }}</p>
            </div>
            <div
              class="l_notation"
              v-html="this.coupon.message"
              v-if="this.showUseButton"
            ></div>
            <div
              class="l_notation"
              v-html="this.coupon.message"
              v-else-if="
                this.statusOfCoupon === this.statusRunning &&
                  this.coupon.type === '1'
              "
            ></div>
          </div>
          <!-- USEボタン -->
          <div
            class="l_use"
            v-bind:class="{
              premium: this.coupon.target_user_type !== '0',
              weborder: this.coupon.weborder_coupon_id
            }"
            v-if="this.showUseButton"
          >
            <a
              @click="tapUseCoupon"
              v-if="this.coupon.type === '1' && this.gifteeVisited === 0"
              >このギフトを使う</a
            >
            <a
              @click="tapUseGiftee"
              v-else-if="this.coupon.type === '1' && this.gifteeVisited === 1"
              >このギフトを見る</a
            >
            <div v-if="this.coupon.weborder_coupon_id" class="use_buttons">
              <div class="twobutton_wapper">
                <div @click="tapUseCoupon" class="twobutton">
                  <div class="icon">
                    <img
                      :src="require('@/assets/img/coupon/eatin-takeout.png')"
                    />
                  </div>
                  <div>
                    <div>
                      <template v-if="this.coupon.not_eat_in === '0'"
                        >イートインまたは<br
                      /></template>
                      テイクアウトで使う
                    </div>
                    <div class="small">(店舗・お電話)</div>
                  </div>
                </div>
              </div>
              <div class="twobutton_wapper with_border">
                <div @click="tapUseCouponWeborder" class="twobutton">
                  <div class="icon">
                    <img :src="require('@/assets/img/coupon/joynet.png')" />
                  </div>
                  <div>
                    ネット注文で<br />
                    使う
                  </div>
                  <div class="small">(Joyネット)</div>
                </div>
              </div>
            </div>
            <div v-else class="use_buttons">
              <div @click="tapUseCoupon">
                <img
                  :src="require('@/assets/img/coupon/only_eatin.png')"
                  style="height:40%; margin:0 10px"
                />
                <span>クーポンを使う</span>
              </div>
            </div>
          </div>

          <div
            v-bind:class="{
              l_use: this.coupon.target_user_type === '0',
              l_use_premium: this.coupon.target_user_type !== '0'
            }"
            v-else-if="
              this.statusOfCoupon !== this.statusCanUse &&
                this.coupon.type === '1'
            "
          >
            <a @click="tapUseGiftee">このギフトを見る</a>
          </div>
          <!-- 利用中ボタン -->
          <div
            v-bind:class="{
              l_using: this.coupon.target_user_type === '0',
              l_using_premium: this.coupon.target_user_type !== '0'
            }"
            v-if="
              this.statusOfCoupon === this.statusRunning &&
                this.coupon.type !== '1'
            "
          >
            <div>
              <p class="c_using__title">ご利用日時</p>
              <p class="c_using__date">{{ this.usedDate }}</p>
            </div>
          </div>

          <!-- 利用終了ボタン -->
          <div class="l_used" v-if="this.statusOfCoupon === this.statusExpired">
            <p>ご利用可能時間が終了しました</p>
          </div>
          <!-- 利用終了ボタン -->
          <div
            class="l_used"
            v-if="this.statusOfCoupon === this.statusStampFull"
          >
            <p>スタンプをためて特典をもらおう！</p>
          </div>
          <!-- 利用終了ボタン -->
          <div
            class="l_used"
            v-if="this.statusOfCoupon === this.statusOffHours"
          >
            <p>クーポン利用可能期間外です</p>
          </div>
        </template>

        <!-- アラート表示 -->
        <template v-if="this.isUseAlert">
          <alert-coupon
            :image="this.coupon.detail_image_url"
            :type="this.coupon.type"
            :isWeborder="this.isWeborder"
            @useCoupon="tapAcceptUseCoupon"
            @cancelCoupon="tapCancelUseCoupon"
          />
        </template>
      </div>
      <!-- エラーパネル -->
      <template v-if="this.isError">
        <error-popup
          :title="this.errorTitle"
          :message="this.errorMessage"
          :label="'閉じる'"
          @submit="() => tapRetryFetch()"
          @close="() => tapErrorClose()"
        />
      </template>
    </template>
  </main>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Modal from '@/_helpers/Modal.js'
import { ErrorCode, ErrorMessage } from '@/api/APIClient'
import DateFormatter from '../utils/DateFormatter.js'
import DateFormatter2 from '../utils/DateFormatter2.js'
import AlertCoupon from '../components/Modal/AlertCoupon'
import ErrorPopup from '@/components/Modal/ErrorPopup.vue'
import { FactoryTrack } from '../constant/firebase'
import '@/styles/color.css'

const categoryNames = ['何度でもご利用可能', '期間限定', '特典', 'あなただけ']

export default {
  name: 'UseCoupon',
  components: {
    AlertCoupon,
    ErrorPopup
  },
  mixins: [Modal],
  data: function() {
    return {
      title: '詳細',
      apiType: '4',
      apiTypeCoupon: '5',
      apiTypePrize: '6',
      couponId: '',
      isUseAlert: false,
      isWeborder: false,
      statusOfCoupon: 0,
      statusCanUse: 0,
      statusRunning: 1,
      statusExpired: 2,
      statusStampFull: 3,
      statusOffHours: 4,
      statusRunningLongPrize: 5,
      startDate: null,
      timerString: '00:00:00',
      termsStr: '',
      isError: false,
      errorMessage: '',
      errorTitle: '',
      errorType: '',
      gifteeVisited: 0,
      isAndroid: false,
      confirm: false,
      isShadow: false
    }
  },
  props: {
    type: null // props route
  },
  created() {
    document.title = this.title // タイトル設定
    const tmpid = this.$route.params.id.split(':')

    this.couponId = tmpid[0]
    this.confirm = tmpid.length === 2
    const accTime = new DateFormatter().format(new Date())
    this.usedDate = new DateFormatter2().format2(new Date())
    try {
      window.receivedToken = payload => {
        console.log(payload)
        const json = JSON.parse(payload)
        this.fetchCouponDetail(
          json.app_token,
          accTime,
          json.user_id,
          json.coupon_id
        )
        window.receivedToken = null
      }
      this.actionRequestToken({
        apiType: this.apiType,
        acc_time: accTime,
        coupon_id: `${this.couponId}`
      })
    } catch (e) {
      this.errorTitle = 'エラー' + ErrorCode.CODE_ERROR_TOKEN
      this.errorMessage = ErrorMessage.MSG_ERROR_TOKEN
      this.isError = true
      this.errorType = 'token'
      console.log(e)
    }
  },
  mounted: function() {
    const ua = window.navigator.userAgent
    if (ua.indexOf('Android') >= 0 && window.innerWidth < 375) {
      this.isAndroid = true
    }
  },
  computed: {
    ...mapGetters({
      coupon: 'Coupon/coupon',
      couponType: 'Coupon/couponType',
      couponDetail: 'UseCoupon/use_coupon',
      gift_url: 'Coupon/gift_url',
      weborder_url: 'Coupon/weborder_url'
    }),
    showUseButton: function() {
      return (
        this.statusOfCoupon === this.statusCanUse ||
        this.statusOfCoupon === this.statusRunningLongPrize
      )
    },
    categoryName: function() {
      return categoryNames[this.coupon.coupon_category]
    }
  },
  watch: {
    // クーポンデータを監視し、初期ステータスを更新する
    coupon: function(value) {
      console.log('%%%%%%%%%%%%%%%%% watch coupon %%%%%%%%%%%%%%%%')
      if (!value) return
      switch (value.status) {
        case '0':
          this.statusOfCoupon = this.statusExpired
          break
        case '1':
          this.statusOfCoupon = this.statusCanUse
          break
        case '2':
          this.statusOfCoupon = this.statusRunning
          break
        case '3':
          this.statusOfCoupon = this.statusStampFull
          break
        case '4':
          this.statusOfCoupon = this.statusRunningLongPrize
          break
      }
      if (value.is_off) {
        this.statusOfCoupon = this.statusOffHours
      }
      if (this.couponType === '0') {
        this.termsStr = value.terms
      } else {
        this.termsStr = value.article
      }
      if (value) {
        const me = this
        this.$nextTick(function() {
          const wrapper = me.$refs.terms_wrapper
          const height = parseInt(wrapper.scrollHeight - wrapper.offsetHeight)
          function sh() {
            me.isShadow = height > wrapper.scrollTop
          }
          wrapper.addEventListener('scroll', sh)
          sh()
        })
      }
    },
    // ステータス変更を監視
    statusOfCoupon: function(value) {
      console.log(`watch statusOfCoupon ${value}`)
      if (value === this.statusRunning && this.coupon.type !== '1') {
        const startDate =
          this.coupon.last_history !== ''
            ? new Date(this.coupon.last_history.replace(/-/g, '/'))
            : new Date()
        console.log(startDate)
        this.usedDate = new DateFormatter2().format2(startDate)
      }
    }
  },
  methods: {
    expireAtStr: function() {
      console.log(this.coupon)
      if (!this.coupon.expire_at) {
        return `ー`
      }
      const expire = this.__createExpiredDate(this.coupon.expire_at)
      if (expire === '9999/12/31 23:59') {
        return `無期限`
      } else {
        return `[有効期限] ${expire}`
      }
    },
    couponColor: function() {
      console.log(this.coupon)
      return {
        diamond: this.coupon.prize_type === '4',
        platinium: this.coupon.prize_type === '3',
        gold: this.coupon.prize_type === '2',
        silver: this.coupon.prize_type === '1'
      }
    },
    ...mapActions('Loading', ['actionToggleLoading']),
    ...mapActions('Native', [
      'actionCallCloseCoupon',
      'actionRequestToken',
      'actionRequestExternalLink',
      'actionCallFreepass',
      'actionAdjustCouponHeight'
    ]),
    ...mapActions('Analytics', ['trackEvent']),
    ...mapActions('Coupon', [
      'actionFetchCouponDetail',
      'actionRequestUseCoupon',
      'actionRequestExchangePrize'
    ]),
    tapRetryFetch() {
      this.trackEvent(FactoryTrack.createErrorRetry())
      this.actionCallCloseCoupon()
    },
    tapErrorClose() {
      this.trackEvent(FactoryTrack.createErrorClose())
      this.isError = false
      this.actionCallCloseCoupon()
    },
    __createExpiredDate(str) {
      const array = str.split(' ')
      const date = array[0].split('-').join('/')
      const time = array[1].split(':')
      return `${date} ${time[0]}:${time[1]}`
    },
    tapClose() {
      this.trackEvent(
        FactoryTrack.createCouponClose(
          this.coupon.coupon_id || this.coupon.prize_id,
          this.coupon.caption
        )
      )
      this.actionCallCloseCoupon()
    },
    /**
     * クーポン詳細
     */
    async fetchCouponDetail(token, accTime, userId, couponId) {
      this.actionToggleLoading(true)
      try {
        await this.actionFetchCouponDetail({
          token: token,
          accTime: accTime,
          userId: userId,
          couponId: couponId
        })
        console.log('coupon', this.coupon)
        console.log('detaio', this.couponDetail)
      } catch (e) {
        this.errorMessage = e.message
        this.errorTitle = 'エラー' + e.code
        this.errorCode = e.code
        this.isError = true
        console.log(e)
      }
      setTimeout(async () => {
        this.actionToggleLoading(false)
        if (this.coupon.prize_type === '0') {
          await this.actionAdjustCouponHeight(
            this.$refs.coupon_detail.clientHeight
          )
        }
        if (this.coupon.prize_type !== '0' && this.confirm) {
          await this.actionAdjustCouponHeight(
            this.$refs.freepass_confirm.clientHeight
          )
        }
      }, 300)
    },
    /**
     * useCoupon APIをコール
     */
    async fetchUseCoupon(token, accTime, userId, couponId, isWeborder = false) {
      this.actionToggleLoading(true)
      try {
        await this.actionRequestUseCoupon({
          token: token,
          accTime: accTime,
          userId: userId,
          couponId: couponId,
          isWeborder
        })
        console.log('*** fetch use coupon success *** :', this.gift_url)

        if (this.coupon.type === '1') {
          this.actionRequestExternalLink(this.gift_url)
          this.gifteeVisited = 1
        } else if (this.weborder_url) {
          this.actionRequestExternalLink(this.weborder_url)
          this.statusOfCoupon = this.statusRunning
        } else {
          this.statusOfCoupon = this.statusRunning
        }
      } catch (e) {
        if (e.code) {
          this.errorMessage = e.message
          this.errorTitle = 'エラー' + e.code
          this.errorCode = e.code
        } else {
          this.errorTitle = 'エラー' + ErrorCode.CODE_ERROR_NETWORK
          this.errorMessage = ErrorMessage.MSG_ERROR_NETWORK
        }
        this.isError = true
        console.log('**** fetch use coupon error ****')
        // -----------------------------------------------
        // this.statusOfCoupon = this.statusRunning // DEBUG
        // -----------------------------------------------
        // TODO: エラーアラート
      }
      setTimeout(async () => {
        this.actionToggleLoading(false)
        if (this.coupon.prize_type === '0') {
          await this.actionAdjustCouponHeight(
            this.$refs.coupon_detail.clientHeight
          )
        }
        if (this.coupon.prize_type !== '0') {
          await this.actionAdjustCouponHeight(
            this.$refs.freepass_confirm.clientHeight
          )
        }
      }, 300)
    },
    /**
     * ExchangePrizeをコール
     */
    async fetchExchangePrize(token, accTime, userId, prizeId, isWeborder) {
      this.actionToggleLoading(true)
      try {
        await this.actionRequestExchangePrize({
          token: token,
          accTime: accTime,
          userId: userId,
          prizeId: prizeId,
          isWeborder
        })
        if (this.weborder_url) {
          this.actionRequestExternalLink(this.weborder_url)
          this.statusOfCoupon = this.statusRunning
        }
        if (this.coupon.prize_type !== '0') {
          if (!this.isWeborder) {
            this.actionCallFreepass(`1-${prizeId}`)
          }
        } else {
          this.statusOfCoupon = this.statusRunning // 画面表示ステータスを変更
        }
      } catch (e) {
        this.errorMessage = e.message
        this.errorTitle = 'エラー' + e.code
        this.errorCode = e.code
        this.isError = true
        console.log(e)
        // TODO: エラーアラート
      }
      setTimeout(async () => {
        this.actionToggleLoading(false)
        if (this.coupon.prize_type === '0') {
          await this.actionAdjustCouponHeight(
            this.$refs.coupon_detail.clientHeight
          )
        }
      }, 300)
    },
    /**
     * gifteeに飛ばす
     */
    tapUseGiftee() {
      try {
        console.log(this.coupon)
        const id = this.coupon.coupon_id || this.coupon.prize_id
        this.trackEvent(
          FactoryTrack.createCouponDetail(id, this.coupon.caption)
        )
      } catch (e) {
        console.log(this.coupon)
      }
      if (this.gifteeVisited === 1) {
        console.log('gift_url 1' + this.coupon)
        this.actionRequestExternalLink(this.gift_url)
      } else {
        console.log('gift_url 2' + this.coupon.gift_url)
        this.actionRequestExternalLink(this.coupon.gift_url)
      }
    },
    /**
     * クーポンを利用する
     */
    tapUseCoupon() {
      try {
        console.log(this.coupon)
        const id = this.coupon.coupon_id || this.coupon.prize_id
        this.trackEvent(
          FactoryTrack.createCouponDetail(id, this.coupon.caption)
        )
      } catch (e) {
        console.log(this.coupon)
      }
      this.isWeborder = false
      this.isUseAlert = true
    },
    /**
     * クーポンを利用する
     */
    tapUseCouponWeborder() {
      try {
        const id = this.coupon.coupon_id || this.coupon.prize_id
        this.trackEvent(
          FactoryTrack.createCouponDetail(id, this.coupon.caption)
        )
      } catch (e) {
        console.log(this.coupon)
      }
      this.isWeborder = true
      this.isUseAlert = true
    },
    /**
     * クーポン利用する承諾
     */
    tapAcceptUseCoupon() {
      try {
        console.log(this.coupon)
        const id = this.coupon.coupon_id || this.coupon.prize_id
        this.trackEvent(FactoryTrack.createUseCoupon(id, this.coupon.caption))
      } catch (e) {
        console.log(this.coupon)
      }
      this.isUseAlert = false
      const accTime = new DateFormatter().format(new Date())
      this.usedDate = new DateFormatter2().format2(new Date())
      const couponData = this.couponId.split('-')
      try {
        window.receivedToken = payload => {
          const json = JSON.parse(payload)
          if (couponData[0] === '0') {
            // 0: クーポン 1: 特典
            this.fetchUseCoupon(
              json.app_token,
              accTime,
              json.user_id,
              json.coupon_id,
              this.isWeborder
            )
          } else {
            this.fetchExchangePrize(
              json.app_token,
              accTime,
              json.user_id,
              json.prize_id,
              this.isWeborder
            )
          }
          window.receivedToken = null
        }
        if (couponData[0] === '0') {
          this.actionRequestToken({
            apiType: this.apiTypeCoupon,
            acc_time: accTime,
            coupon_id: `${couponData[1]}`,
            is_weborder: this.isWeborder ? '1' : '0'
          }) // クーポン
        } else {
          this.actionRequestToken({
            apiType: this.apiTypePrize,
            acc_time: accTime,
            prize_id: `${couponData[1]}`,
            is_weborder: this.isWeborder ? '1' : '0'
          }) // 特典
        }
      } catch (e) {
        this.fetchUseCoupon('', '', '', '')
      }
    },
    /**
     * クーポン利用する拒否
     */
    tapCancelUseCoupon() {
      try {
        const id = this.coupon.coupon_id || this.coupon.prize_id
        this.trackEvent(
          FactoryTrack.createCancelCoupon(id, this.coupon.caption)
        )
      } catch (e) {
        console.log(this.coupon)
      }
      this.isUseAlert = false
    },
    /**
     * クーポンタイマーの開始
     * @param {Date} startDate
     */
    __startCouponTimer(startDate) {
      this.startDate = startDate
      console.log(this.startDate)
      window.requestAnimationFrame(this.__updateFrame)
    },
    /**
     * アニメーションフレーム
     */
    __updateFrame() {
      const limitTime = this.startDate.getTime() + 1000 * 60 * 60
      const dist = limitTime - new Date().getTime()

      if (dist > 0) {
        this.timerString = this.computeDuration(dist)
        window.requestAnimationFrame(this.__updateFrame)
      } else {
        this.timerString = '00:00:00'
        this.statusOfCoupon = this.statusExpired
      }
    },
    // 日付計算
    computeDuration(duration) {
      const hour = Math.floor(duration / 3600000)
      const minute = Math.floor((duration - 3600000 * hour) / 60000)

      // const hh = ('00' + hour).slice(-2);
      const mm = ('00' + minute).slice(-2)
      const ms = ('00000' + (duration % 60000)).slice(-5)
      const time = `${mm}:${ms.slice(0, 2)}:${ms.slice(2, 4)}`
      return time
    },
    // timer
    updateCurrentTime: function() {
      if (this.$data.state === 'started') {
        this.stopTime =
          new Date(this.getLastHistory).getTime() +
          this.stopTimeInMinutes * 60000 // 2019-06-21 - add new line
        this.distance = this.stopTime - Date.now() // 2019-06-20 update
        if (this.distance < 0) {
          this.$data.state = 'paused'
          this.finished = true
          clearInterval(this.interval) // stop Interval
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
main {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center
}

.freepass_confirm {
  overflow: hidden;
  border-radius: 6px;
  background-color: #ffffff;
  position: relative;

  display: flex;
  flex-direction: column;
  height: auto;

  .header {
    display: flex;
    justify-content: center;
    align-items: center;

    padding: 10px;
    background-color: #eeeeee;
    color: #787878;
    font-weight: bold;
    font-size: 4vw;
  }

  .condition {
    padding: 10px;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    font-size: 6vw;

    .caption {
      font-weight: bold;
      color: #333333;
    }

    .term {
      font-size: 3.5vw;
      color: #767676;
      text-align: left;
      white-space: pre-wrap;
      overflow-y: scroll;
    }

    .expired {
      color: red;
      font-weight: bold;
      font-size: 5vw;
      padding-top: 10px;
    }
  }

  .button {
    font: 30px;
  }
}

.freepass {
  background-color: black;
  color: white;
  position: relative;
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;

  .image {
    width: 100%;
    background-color: transparent;
    position: relative;
    margin-bottom: 10px;

    img {
      width: 100%;
    }
    .expire {
      position: absolute;
      top: 57%;
      left: 0;
      right: 0;
    }

  }

  .usetime {
    margin-bottom: 10px;

    p {
      font-size: 36px;
      font-weight: bold;
    }
  }

  .detail {
    text-align: left;
    padding: 10px;
    font-size: 12px;
    display: flex;
    flex-direction: column;
    overflow: scroll;
    flex: 2 2 0;

    .header {
      font-weight: bold;
    }

    // .body {
    //   overflow: scroll;
    //   flex-grow: 1;
    // }
  }

  .close {
    .close_button {
      display: inline-block;
      font-size: 14px;
      font-weight: bold;
      background-color: #66160E;
      padding: 8px 60px;
      border-radius: 5px;
      margin: 20px auto;
    }
  }

  &.diamond {
    background-color: #000000;

    .expire {
      color: #e3c841;
    }

    .close_button {
      background-color: #deaa07;
    }
  }

  &.platinium {
    background-color: #6ea1c7;
  }

  &.gold {
    background-color: #c0a417;
  }

  &.silver {
    background-color: #9f9f9f;
  }
}

.l_coupon__detail {
  overflow: hidden;
  border-radius: 6px;
  background-color: var(--background-color);
  position: relative;
}

/* header */
.l_coupon__header {
  width: 100%;
  height: 35px;
  display: flex;
  /* establish flex container */
  flex-direction: row;
  /* default value; can be omitted */
  flex-wrap: nowrap;
  /* default value; can be omitted */
  justify-content: space-between;
  /* switched from default (flex-start, see below) */
}


/* 有効期限 */
.l_expireAt {
  display: flex;
  align-items: center;
  padding: 0 0 0 10px;
  position: relative;
}

.c_coupon__expire {
  background-color: #eeeeee;
  width: 60%;
  height: 35px;
  border-top-right-radius: 10px;
  font-size: 11px;
}

/* カテゴリーラベル */
.l_category {
  display: flex;
  align-items: center;
  width: 40%;
  height: 35px;
  justify-content: center;
  background-color: #efb80c;
}

.l_category_premium {
  display: flex;
  align-items: center;
  width: 40%;
  height: 35px;
  justify-content: center;
  background-image: url('~@/assets/img/premium/tab_on.png');
  background-size: cover;
  background-position: center;
}

.c_category__normal {
  background-color: #efb80c;
}

.c_expire__label {
  font-family: 'HiraKakuPro-W6';
  font-size: 11px;
  color: #666;
  text-align: left;
}

.c_category__label {
  font-family: 'HiraKakuPro-W6';
  font-size: 11px;
  color: #ffffff;
}

.c_category__img {
  width: 16px;
  margin-right: 3px;
}

.c_red {
  background-color: #cc0000;
}

.c_pink {
  background-color: #e3587f;
}

/* クーポン */
.l_coupon {
  display: flex;
  align-items: stretch;
  width: 100%;
}

.l_coupon__large {
  overflow: hidden;
  /* height: 128px; */
  width: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  img {
    width: 100%;
  }
}

.l_coupon__left {
  flex: 0 0 160px;
  overflow: hidden;
  height: 128px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.l_coupon__right {
  flex: 1 1 auto;
  padding: 12px 12px;
  position: relative;
  text-align: left;
  background: #ffffff;
}

.c_img {
  max-width: 100%;
  width: 100%;
}

.c_coupon__title {
  font-family: 'HiraKakuPro-W6';
  font-size: 3vw;
  line-height: 1.38;
  letter-spacing: normal;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}

.l_heading {
  position: absolute;
  bottom: 15px;
}

.c_coupon__heading {
  font-size: 7vw;
  line-height: 1;
  color: #e03535;
  font-weight: 800;
  margin-top: 3px;
}

.c_coupon__heading.is_android {
  font-size: 24px;
}

.c_coupon__subtitle {
  font-size: 3.5vw;
  line-height: 1.38;
  font-weight: 800;
  letter-spacing: normal;
  color: #e03535;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}

/* 利用時間ご注意 */
.l_condition {
  padding: 8px 12px 11px 12px;
}

.l_terms {
  position: relative;
  height: 154px;
  overflow-y: scroll;
}
.scroll_shadow {
  background: linear-gradient(
    0deg,
    rgba(85, 85, 85, 1) 0%,
    rgba(255, 255, 255, 0) 10%,
    rgba(255, 255, 255, 0) 100%
  );
}
.l_notation {
  margin-top: 8px;
}

.c_terms {
  font-size: 11px;
  color: #333;
  text-align: left;
  white-space: pre-wrap;
  margin-bottom: 8px;
}

.l_notation {
  font-family: 'HiraKakuPro-W6';
  font-size: 12px;
  color: #000;
  line-height: 18px;
}

/* 使うボタン */
.l_use {
  background: #cc3300;
  color: #ffffff;
  font-family: 'HiraKakuPro-W6';
  font-size: 16px;
  /* padding: 23px; */
  height: 100px;
  line-height: 1;

  background-size: cover;
  background-position: center;

  &.weborder {
    height: auto;
  }

  display: flex;
  align-items: center;
  justify-content: center;

  &.weborder {
    height: auto;
    display: inherit;



    //&.premium {
    //   background-image: url('~@/assets/img/buttons/FP_DIAMOND.png') !important;
    // }
}

  .use_buttons {
    width: 100%;
    height: 100%;
    /* display: flex;
    justify-content: space-around;
    align-items: center; */
    > div {
      display: flex;
      height: 100%;
      align-items: center;
      width: 100%;
      justify-content: center;
    }
    .with_border {
      border-left: 1px solid;
    }
    .twobutton_wapper {
      display: inline-block;
      width: 50%;
      .twobutton {
        display: flex;
        flex-direction: column;
        padding: 10px 0;
        .icon {
          height: 30px;
          img {
            height: 100%;
          }
        }
        > div {
          margin: 2px 0;
          &.small {
            font-size: 12px;
          }
        }
      }
    }
  }
  &.premium {
    background-image: url('~@/assets/img/premium/tab_on.png');
    background-size: cover;
    background-position: center;
  }

  &.silver {
    background-image: url('~@/assets/img/buttons/FP_SILVER.png') !important;
  }

  &.gold {
    background-image: url('~@/assets/img/buttons/FP_GOLD.png') !important;
  }

  &.platina {
    background-image: url('~@/assets/img/buttons/FP_PLATINA.png') !important;
  }

  &.diamond {
    background-image: url('~@/assets/img/buttons/FP_DIAMOND.png') !important;
  }

}

/* 残り時間 */
.l_using {
  background: #56b212;
  color: #ffffff;
  line-height: 1;
  height: 137px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.l_using_premium {
  background-image: url('~@/assets/img/premium/tab_on.png');
  background-size: cover;
  background-position: center;
  color: #ffffff;
  line-height: 1;
  height: 137px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.c_using__title {
  font-family: 'HiraKakuPro-W6';
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
}

.c_using__time {
  font-size: 18vw;
  font-weight: bold;
  width: 270px;
  text-align: center;
  margin: 0 auto;
  font-family: sans-serif;
}

.c_using__date {
  font-size: 10vw;
  font-weight: bold;
  text-align: center;
  margin: 0 auto;
}

/* 利用終了 */
.l_used {
  background: #999;
  color: #ffffff;
  font-family: 'HiraKakuPro-W6';
  font-size: 16px;
  padding: 23px;
  line-height: 1;
  margin-top: 62px;
}

/* 閉じるボタン */
.l_button__close {
  position: absolute;
  top: 11px;
  right: 5px;
}

.c_button__close {
  width: 15px;
  border: none;
  outline: none;
  appearance: none;
  background: none;
}

.c_close {
  width: 12px;
}

.c_text__red {
  color: #cc0000;
}

.inner {
  display: flex;
  vertical-align: middle;
  margin: 1px;
}

@media screen and (max-width: 320px) {
  .c_coupon__heading {
    font-size: 20px;
    line-height: 1;
  }

  .c_using__time {
    font-size: 40px;
    text-align: center;
    margin: 0 auto;
  }

  .l_using {
    padding: 20px;
  }

  .c_coupon__expire {
    padding: 0 30px 0 10px;
    line-height: 1.4;
  }

  .l_terms {
    position: relative;
    height: 142px;
    overflow-y: scroll;
  }

  .l_used {
    margin-top: 74px;
  }

  .l_heading {
    position: absolute;
    bottom: 10px;
  }

  .l_coupon__right {
    padding: 8px 10px;
  }

  .l_condition {
    padding: 12px 12px 15px 12px;
  }

  .l_notation {
    margin-top: 12px;
  }

  .c_notation {
    font-feature-settings: 'pwid' 1;
    -webkit-font-smoothing: antialiased;
  }

  .inner {
    display: inline-block;
    vertical-align: middle;
    margin: 1px;
  }

}
</style>
